<template>
  <!--  <distanceDemo></distanceDemo>-->

  <h-file-upload download delete v-model="file" @error="error" @change="change(2)" @download="download"></h-file-upload>

</template>

<script>
import distanceDemo from "../distance/demo/index"
import change from "@icon-park/vue-next/lib/icons/Change";

export default {
  name: "h-help",
  computed: {},
  components: {
    distanceDemo
  },
  data() {
    return {
      loading: null,
      file: {}
    }
  },

  methods: {
    error(value) {
      this.warning(value.message)
    },
    change(file, c) {
      // console.log(file, c)
    },
    download(file, c) {
      // console.log(file, c)
    }
  },
  mounted() {

  }
}
</script>

<style lang="scss" scoped>

</style>
